import { LandingPage } from "./LandingPage";
import { CONTENT_FR } from "./content/fr";
import { CONTENT_NL } from "./content/nl";
import { CONTENT_VILLES } from "./content/villes";
import routes from "./routes.json";

/* Routes publiques SEO (pages d'atterrissage FR/NL) dérivées de routes.json. "/" reste la page d'accueil existante. */
export const SEO_LANDINGS = routes
  .filter((r) => r.content && r.path !== "/")
  .map((r) => ({ path: r.path, element: <LandingPage path={r.path} content={(r.villes ? CONTENT_VILLES : r.lang === "nl" ? CONTENT_NL : CONTENT_FR)[r.content]} /> }));
